import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1M_44_1W_5_19',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_44_1w_5_19_usd',
			EUR: 'simple_premium_1m_44_1w_5_19_eur',
			AUD: 'simple_premium_1m_72_1w_7_99_aud',
			CAD: 'simple_premium_1m_72_1w_7_99_cad',
			GBP: 'simple_premium_1m_44_1w_5_19_gbp',
			DKK: 'simple_premium_1m_379_1w_39_dkk',
			NOK: 'simple_premium_1m_579_1w_59_nok',
			SEK: 'simple_premium_1m_579_1w_59_sek',
			TRY: 'simple_premium_1m_1429_1w_169_try',
			BRL: 'simple_premium_1m_179_1w_17_brl',
			MXN: 'simple_premium_1m_729_1w_79_mxn',
			ARS: 'simple_premium_1m_58699_1w_6590_ars',
			COP: 'simple_premium_1m_175999_1w_19990_cop',
			CLP: 'simple_premium_1m_44000_1w_4790_clp',
		},
		primer: 'prd_w6vppNiqPBJC',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 5.19,
			EUR: 5.19,
			AUD: 7.99,
			CAD: 7.99,
			GBP: 5.19,
			DKK: 39,
			NOK: 59,
			SEK: 59,
			TRY: 169,
			BRL: 17,
			MXN: 79,
			ARS: 6590,
			COP: 19990,
			CLP: 4790,
		},
		originalPriceMap: {
			USD: 22,
			EUR: 22,
			GBP: 22,
			CAD: 15.99,
			AUD: 15.99,
			DKK: 75,
			NOK: 114,
			SEK: 114,
			TRY: 325,
			BRL: 34,
			MXN: 152,
			ARS: 12699,
			COP: 38479,
			CLP: 9220,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 44,
			EUR: 44,
			AUD: 72,
			CAD: 72,
			GBP: 44,
			DKK: 379,
			NOK: 579,
			SEK: 579,
			TRY: 1429,
			BRL: 179,
			MXN: 729,
			ARS: 58699,
			COP: 175999,
			CLP: 44000,
		},
	},
}
